import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  lifecycle,
  withHandlers,
  withState
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import moment from 'moment';
import Header from '../../components/Header';
import SearchButton from '../../components/atoms/SearchButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { sendLogin } from '../../auth/Auth';
import MenuBox from '../../components/MenuBox';
import {
  getDonateHistoryGochiKid,
  GET_DONATE_HISTORY_GOCHI_KID_SUCCESS
} from '../../actions/Options';

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      backgroundColor: '#F7F7F7',
      margin: '0 auto'
    }
  },
  pageTitileDiv: {
    textAlign: 'left',
    marginBottom: 10
  },
  mainContent: {
    padding: 15
  },
  mainPaper: {
    position: 'relative'
  },
  searchForm: {
    padding: '10px 20px 20px 20px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '100%'
  },
  title: {
    fontSize: '24px',
    fontWeight: 700
  },
  buttonSend: {
    marginLeft: 'auto',
    height: 22,
    fontSize: 12,
    padding: 0
  },
  textCenter: {
    textAlign: 'center',
    marginTop: 15
  },
  searchCollapseBox: {
    marginBottom: '20px'
  },
  gochiBox: {
    padding: 16
  },
  tableInfo: {
    width: '100%',
    marginBottom: 20
  },
  tableInfoHeadCellHeader: {
    backgroundColor: '#525A60',
    color: '#FFFFFF',
    padding: '8px 12px',
    width: '110px',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  tableInfoHeadCell: {
    backgroundColor: '#525A60',
    color: '#FFFFFF',
    padding: '8px 12px',
    fontSize: '14px',
    lineHeight: '22px'
  },
  tableInfoCellHeader: {
    padding: '8px 12px',
    width: '110px',
    borderBottom: '1px solid #E0E0E0',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#000000',
    backgroundColor: '#F7F7F7'
  },
  tableInfoCell: {
    padding: '8px 12px',
    borderBottom: '1px solid #E0E0E0',
    fontSize: '14px',
    color: '#000000',
    whiteSpace: 'break-spaces',
    wordBreak: 'break-all',
    lineHeight: '22px'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators({ getDonateHistoryGochiKid }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('hasMore', 'setHasMore', false),
  withState('nextHref', 'setNextHref', 1),
  withState('listDonate', 'setListDonate', []),
  withState('donateAtFrom', 'setDonateAtFrom', null),
  withState('donateAtTo', 'setDonateAtTo', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangePage: props => page => {
      const searchKey = {
        page,
        limit: 15,
        donateAtFrom: props.donateAtFrom,
        donateAtTo: props.donateAtTo
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getDonateHistoryGochiKid(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          let list = [];
          if (page > 1) {
            list = props.listDonate;
          } else {
            list = [];
            props.setNextHref(1);
          }

          if (data.type === GET_DONATE_HISTORY_GOCHI_KID_SUCCESS) {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);

            if (data.payload.list) {
              data.payload.list.map(menu => {
                return list.push(menu);
              });
              props.setListDonate(list);
              if (data.payload.offset + 15 < data.payload.count) {
                props.setHasMore(true);
              } else {
                props.setHasMore(false);
              }
            }
          } else {
            props.setResultMessage('エラーが発生しました！');
            props.updateLoading(false);
          }
        })
        .catch(error => {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          console.log(error);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.handleChangePage(1);
    }
  })
);

const Main = enhance(
  ({
    classes,
    account,
    updateOpenDrawer,
    loading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    hasMore,
    nextHref,
    setNextHref,
    donateAtFrom,
    setDonateAtFrom,
    donateAtTo,
    setDonateAtTo,
    listDonate,
    setListDonate,
    handleChangePage
  }) => {
    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const searchAction = () => {
      setListDonate([]);
      setNextHref(1);
      handleChangePage(1);
    };

    const loadMoreMenus = async () => {
      setNextHref(nextHref + 1);
      handleChangePage(nextHref + 1);
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />

        <div className={classes.mainContent}>
          <div className={classes.pageTitileDiv}>
            <Typography color="textPrimary" className={classes.title}>
              こどもごちめし支援額詳細
            </Typography>
          </div>
          <div className={classes.searchCollapseBox}>
            <Paper className={classes.mainPaper} elevation={1}>
              <div className={classes.searchForm}>
                <div>
                  <TextField
                    label="支援日時(From)"
                    type="date"
                    className={classes.textField}
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={donateAtFrom}
                    onChange={e => {
                      setDonateAtFrom(e.target.value);
                    }}
                    onBlur={e => {
                      if (!donateAtFrom) {
                        e.target.value = '';
                        setDonateAtFrom('');
                      }
                    }}
                  />
                  <TextField
                    label="支援日時(To)"
                    type="date"
                    className={classes.textField}
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={donateAtTo}
                    onChange={e => {
                      setDonateAtTo(e.target.value);
                    }}
                    onBlur={e => {
                      if (!donateAtTo) {
                        e.target.value = '';
                        setDonateAtTo('');
                      }
                    }}
                  />
                </div>
                <div className={classes.textLeft}>
                  <SearchButton onClickAction={searchAction} />
                </div>
              </div>
            </Paper>
          </div>

          <Paper>
            <div className={classes.infiniteScroll}>
              <div className="select-block-body m-0">
                <div className="lst-friends h-100">
                  <div className={classes.gochiBox}>
                    {listDonate &&
                      listDonate.map(item => (
                        <Table
                          className={classes.tableInfo}
                          key={item.gochiKidDonateLogId}
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell
                                className={classes.tableInfoHeadCellHeader}
                              >
                                支援日時
                              </TableCell>
                              <TableCell className={classes.tableInfoHeadCell}>
                                {moment(item.donateAt).format('YYYY-MM-DD')}
                                <br />
                                {moment(item.donateAt).format('THH:mm:ss')}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell
                                className={classes.tableInfoCellHeader}
                              >
                                支援額
                              </TableCell>
                              <TableCell className={classes.tableInfoCell}>
                                {item.donateAmount
                                  ? item.donateAmount.toLocaleString()
                                  : 0}
                                円
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                className={classes.tableInfoCellHeader}
                              >
                                こども達へのメッセージ
                              </TableCell>
                              <TableCell className={classes.tableInfoCell}>
                                {item.donateMessage}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </Paper>

          {hasMore && (
            <div className={classes.textCenter}>
              <Button
                variant="contained"
                color="primary"
                siz="xs"
                onClick={() => {
                  loadMoreMenus();
                }}
              >
                もっと見る
              </Button>
            </div>
          )}
        </div>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        <MenuBox account={account} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
